import Vue from "vue";

class AssetsMwcService {
  constructor() { }

  getAssetsMwc() {
    return Vue.localStorage.get('assetsMwc');
  }
}

export default new AssetsMwcService();
